// Determina si una URL apunta fuera del origen actual (dominio distinto),
// para decidir entre navegación interna (SPA router) o external (nueva pestaña).
export function isExternalUrl(url: string): boolean {
  try {
    return new URL(url, window.location.origin).origin !== window.location.origin;
  } catch {
    return false;
  }
}
